<template>
  <div class="pbar">
    <div class="pbar__inner" :style="`transform: translateX(${Math.min((-76) * (step - 2),0)}px)`">
      <template v-for="i in count" :key="i + texts[i-1]">
        <PBarPoint :class="{ 'active': step == i }" :state="Math.sign(step - i)" :text="texts[i - 1]" />
        <div class="pbar__filler" v-if="i < count"></div>
      </template>
    </div>
    <div class="pbar__text">Шаг {{ Math.min(step,count) }} из {{ count }}</div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import PBarPoint from './PBarPoint.vue';

export default {
  components: { PBarPoint },
  data: () => ({
    transitions: 0,
    texts:
      [
        'Данные о договоре',
        'Информация о событии',
        'Данные Заявителя',
        'Контакты',
        'Выгодоприобретатель',
        'Документы',
        'Реквизиты'
      ]
  }),
  methods: {
    changeHeight(full) {
      if (!this.transitions)
        this.$el.style.setProperty('height', this.$el.offsetHeight + 'px')
      window.requestAnimationFrame(()=>{
        this.transitions++
        let to = full? (this.$el.scrollHeight + 'px') : '0px'
        this.$el.style.setProperty('height', to)
        if (!full)
          this.$el.style.setProperty('margin-bottom', to)
        else
          this.$el.style.removeProperty('margin-bottom')
        setTimeout(()=>{
          this.transitions--
          if (!this.transitions && full)
            this.$el.style.removeProperty('height')
        }, 410)
      })
    }
  },
  computed: {
    count() {
      return this.texts?.length || 0
    },
    hidden() {
      return this.step > this.count
    },
    ...mapState(["step"])
  },
  watch: {
    hidden(v, old) {
      if (v != old)
        this.changeHeight(!v)   
    }
  }
}
</script>

<style lang="sass" scoped>
.pbar
  transition: .4s ease-out
  overflow: hidden
  width: calc(100% + 4000px)
  padding-left: 2000px
  margin-left: -2000px
  margin-right: -2000px
  padding-right: 2000px
  &__inner
    display: flex
    align-items: center
    transition: transform .4s ease-out
    @include since(768px)
      transform: none !important

  &__text
    text-align: center
    font-size: 14px
    line-height: 1.26
    color: colors.$gray5
    margin: 24px 0 0
    display: none
    @include for-mob
      display: block
  &__filler
    flex-grow: 1
    margin: 0 8px
    height: 1px
    background: colors.$moar_silver_for_the_god_of_silver
    border-radius: 2px
    flex-basis: 16px
    flex-shrink: 0
</style>